<template>
  <div
    class="flex flex-col items-center justify-center cursor-pointer border-2 h-[26px] w-[26px] mr-2 debug-small"
    :class="StateBackground"
    @click="focus()"
  >
    <svg
      class="w-[14px]"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 251.814 309.455"
    >
      <g transform="translate(-169.637 -13.117)">
        <path
          d="M388.07,322.556V310.427H203.01v12.141H181.782V310.427h-.445a11.7,11.7,0,0,1-11.7-11.7V84.617A35.089,35.089,0,0,1,204.73,49.528H345.589V13.117h21.252v36.4h19.521a35.089,35.089,0,0,1,35.089,35.089V298.731a11.7,11.7,0,0,1-11.7,11.7H409.3v12.141Z"
          fill="#fff"
        />
        <path
          d="M324.857,153.852l59.176,53.077a4.166,4.166,0,0,0,6.157-.619l11.562-14.735a4.867,4.867,0,0,0-.485-6.518L342.12,131.928a4.165,4.165,0,0,0-5.88.349q-.132.149-.249.309l-11.58,14.72a4.867,4.867,0,0,0,.446,6.546"
          fill="#3e3e3e"
        />
        <path
          d="M402.421,185.627a14.211,14.211,0,1,1-20.023,1.745,14.211,14.211,0,0,1,20.023-1.745"
          fill="#fff"
        />
        <path
          d="M402.415,185.633a14.2,14.2,0,1,1-20.01,1.744,14.2,14.2,0,0,1,20.01-1.744Z"
          fill="none"
          stroke="#545454"
          stroke-miterlimit="4.001"
          stroke-width="5.85"
        />
        <path
          d="M340.086,126.074a17.128,17.128,0,1,1-24.131,2.1,17.128,17.128,0,0,1,24.131-2.1"
          fill="#9f9f9f"
        />
        <path
          d="M338.2,128.314a14.2,14.2,0,1,1-20.01,1.744,14.2,14.2,0,0,1,20.01-1.744Z"
          fill="none"
          stroke="#545454"
          stroke-miterlimit="4.001"
          stroke-width="5.85"
        />
        <path
          d="M319.938,150.073a14.205,14.205,0,1,1,20.014-1.745,14.205,14.205,0,0,1-20.014,1.745"
          fill="#fff"
        />
        <path
          d="M336.327,130.555a11.281,11.281,0,1,0,1.385,15.893,11.281,11.281,0,0,0-1.385-15.893m3.761-4.48a17.13,17.13,0,1,1-24.134,2.1,17.13,17.13,0,0,1,24.134-2.1"
          fill="#545454"
        />
        <path
          d="M266.179,153.839l-59.168,53.086a4.159,4.159,0,0,1-6.156-.636l-11.58-14.719a4.867,4.867,0,0,1,.485-6.518l59.173-53.136a4.163,4.163,0,0,1,5.879.351c.086.1.166.2.242.3l11.58,14.719a4.867,4.867,0,0,1-.455,6.554"
          fill="#3e3e3e"
        />
        <path
          d="M206.892,207.38a14.2,14.2,0,1,1,1.744-20.01,14.2,14.2,0,0,1-1.744,20.01"
          fill="#fff"
        />
        <path
          d="M206.892,207.38a14.2,14.2,0,1,1,1.744-20.01A14.2,14.2,0,0,1,206.892,207.38Z"
          fill="none"
          stroke="#545454"
          stroke-miterlimit="4.001"
          stroke-width="5.85"
        />
        <path
          d="M271.1,150.06a14.2,14.2,0,1,1,1.744-20.01,14.2,14.2,0,0,1-1.744,20.01"
          fill="#fff"
        />
        <path
          d="M271.1,150.06a14.2,14.2,0,1,1,1.744-20.01,14.2,14.2,0,0,1-1.744,20.01Z"
          fill="none"
          stroke="#545454"
          stroke-miterlimit="4.001"
          stroke-width="5.85"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import { ref } from "vue";
import { dockStateColor } from "@/utils/Utils.js";

export default {
  props: {
    config: Object,
    size: String,
  },
  setup() {
    return {
      SvgClose: ref(`
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 591.092 322.568">
          <defs>
            <clipPath id="clip-path">
              <rect width="591.092" height="322.568" fill="none"/>
            </clipPath>
          </defs>
          <g id="Groupe_279" data-name="Groupe 279" clip-path="url(#clip-path)">
            <path d="M388.07,322.556V310.427H203.01v12.141H181.782V310.427h-.445a11.7,11.7,0,0,1-11.7-11.7V84.617A35.089,35.089,0,0,1,204.73,49.528H345.589V13.117h21.252v36.4h19.521a35.089,35.089,0,0,1,35.089,35.089V298.731a11.7,11.7,0,0,1-11.7,11.7H409.3v12.141Z" fill="#fff"/>
            <path d="M324.857,153.852l59.176,53.077a4.166,4.166,0,0,0,6.157-.619l11.562-14.735a4.867,4.867,0,0,0-.485-6.518L342.12,131.928a4.165,4.165,0,0,0-5.88.349q-.132.149-.249.309l-11.58,14.72a4.867,4.867,0,0,0,.446,6.546" fill="#3e3e3e"/>
            <path d="M402.421,185.627a14.211,14.211,0,1,1-20.023,1.745,14.212,14.212,0,0,1,20.023-1.745" fill="#fff"/>
            <path d="M402.415,185.633a14.2,14.2,0,1,1-20.01,1.744A14.2,14.2,0,0,1,402.415,185.633Z" fill="none" stroke="#545454" stroke-miterlimit="4.001" stroke-width="5.85"/>
            <path d="M340.086,126.074a17.128,17.128,0,1,1-24.131,2.1,17.129,17.129,0,0,1,24.131-2.1" fill="#9f9f9f"/>
            <path d="M338.2,128.314a14.2,14.2,0,1,1-20.01,1.744A14.2,14.2,0,0,1,338.2,128.314Z" fill="none" stroke="#545454" stroke-miterlimit="4.001" stroke-width="5.85"/>
            <path d="M319.938,150.073a14.205,14.205,0,1,1,20.014-1.745,14.223,14.223,0,0,1-20.014,1.745" fill="#fff"/>
            <path d="M336.327,130.555a11.281,11.281,0,1,0,1.385,15.893,11.294,11.294,0,0,0-1.385-15.893m3.761-4.48a17.13,17.13,0,1,1-24.134,2.1,17.131,17.131,0,0,1,24.134-2.1" fill="#545454"/>
            <path d="M266.179,153.839l-59.168,53.086a4.159,4.159,0,0,1-6.156-.636l-11.58-14.719a4.867,4.867,0,0,1,.485-6.518l59.173-53.136a4.163,4.163,0,0,1,5.879.351c.086.1.166.2.242.3l11.58,14.719a4.867,4.867,0,0,1-.455,6.554" fill="#3e3e3e"/>
            <path d="M206.892,207.38a14.2,14.2,0,1,1,1.744-20.01,14.2,14.2,0,0,1-1.744,20.01" fill="#fff"/>
            <path d="M206.892,207.38a14.2,14.2,0,1,1,1.744-20.01A14.2,14.2,0,0,1,206.892,207.38Z" fill="none" stroke="#545454" stroke-miterlimit="4.001" stroke-width="5.85"/>
            <path d="M271.1,150.06a14.2,14.2,0,1,1,1.744-20.01,14.2,14.2,0,0,1-1.744,20.01" fill="#fff"/>
            <path d="M271.1,150.06a14.2,14.2,0,1,1,1.744-20.01A14.2,14.2,0,0,1,271.1,150.06Z" fill="none" stroke="#545454" stroke-miterlimit="4.001" stroke-width="5.85"/>
          </g>
        </svg>
      `),
      SvgOpen: ref(`
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 591.092 322.568">
          <defs>
            <clipPath id="clip-path">
              <rect id="Rectangle_318" data-name="Rectangle 318" width="591.092" height="322.568" fill="none"/>
            </clipPath>
          </defs>
          <g id="Groupe_281" data-name="Groupe 281" clip-path="url(#clip-path)">
            <path d="M416.712,210.937a9.973,9.973,0,0,1-4.583-1.116l-67.953-35.1H246.959l-67.953,35.11a9.977,9.977,0,0,1-9.364-.1v89a11.7,11.7,0,0,0,11.7,11.7h.445v12.141h21.229V310.427H388.069v12.129l21.228.012V310.427h.457a11.7,11.7,0,0,0,11.7-11.7V209.745a10.038,10.038,0,0,1-4.738,1.192" fill="#fff"/>
            <path d="M468.74,58.123l-16.9-8.726,17.784-27.44-18.394-9.5-17.79,27.449-43.32-22.372L314.2,134.682a17.352,17.352,0,0,0,3.151,14.934l99.369,51.319,65.25-100.674c9.468-14.609,3.545-33.476-13.228-42.138" fill="#fff"/>
            <path d="M277.219,135.149,201.393,18.208,122.8,58.816c-16.776,8.668-22.764,27.419-13.384,41.886l65,100.249,99.682-51.5a17.313,17.313,0,0,0,3.121-14.3" fill="#fff"/>
            <path d="M355.422,125.285l24.641,75.577a4.165,4.165,0,0,0,5.64,2.547l17.386-6.964a4.867,4.867,0,0,0,2.844-5.885l-24.589-75.607a4.166,4.166,0,0,0-5.265-2.642,3.883,3.883,0,0,0-.371.143l-17.394,6.941a4.868,4.868,0,0,0-2.892,5.89" fill="#3e3e3e"/>
            <path d="M406.639,191.634a14.2,14.2,0,1,1-18.194-8.511,14.2,14.2,0,0,1,18.194,8.511" fill="#fff"/>
            <path d="M406.639,191.634a14.2,14.2,0,1,1-18.194-8.511A14.2,14.2,0,0,1,406.639,191.634Z" fill="none" stroke="#545454" stroke-miterlimit="4.001" stroke-width="5.85"/>
            <path d="M382.514,108.867A17.128,17.128,0,1,1,360.574,98.6a17.128,17.128,0,0,1,21.94,10.263" fill="#9f9f9f"/>
            <path d="M379.765,109.864a14.2,14.2,0,1,1-18.194-8.511A14.2,14.2,0,0,1,379.765,109.864Z" fill="none" stroke="#545454" stroke-miterlimit="4.001" stroke-width="5.85"/>
            <path d="M353.056,119.551a14.205,14.205,0,1,1,18.2,8.512,14.222,14.222,0,0,1-18.2-8.512" fill="#fff"/>
            <path d="M377.016,110.863a11.281,11.281,0,1,0-6.76,14.45,11.294,11.294,0,0,0,6.76-14.45m5.5-1.994A17.13,17.13,0,1,1,360.571,98.6a17.131,17.131,0,0,1,21.944,10.265" fill="#545454"/>
            <path d="M235.623,125.281l-24.616,75.585a4.157,4.157,0,0,1-5.646,2.533l-17.4-6.938a4.866,4.866,0,0,1-2.845-5.884l24.6-75.63a4.163,4.163,0,0,1,5.264-2.642c.122.04.242.086.359.137l17.4,6.939a4.867,4.867,0,0,1,2.889,5.9" fill="#3e3e3e"/>
            <path d="M210.036,200.921a13.036,13.036,0,1,1-7.815-16.7,13.037,13.037,0,0,1,7.815,16.7" fill="#fff"/>
            <path d="M211.132,201.319a14.2,14.2,0,1,1-8.514-18.192A14.2,14.2,0,0,1,211.132,201.319Z" fill="none" stroke="#545454" stroke-miterlimit="4.001" stroke-width="5.85"/>
            <path d="M237.991,119.544a14.2,14.2,0,1,1-8.514-18.192,14.2,14.2,0,0,1,8.514,18.192" fill="#fff"/>
            <path d="M237.991,119.544a14.2,14.2,0,1,1-8.514-18.192A14.2,14.2,0,0,1,237.991,119.544Z" fill="none" stroke="#545454" stroke-miterlimit="4.001" stroke-width="5.85"/>
          </g>
        </svg>
      `),
      SvgOpening: ref(`
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 591.097 322.568">
          <defs>
            <clipPath id="clip-path">
              <rect id="Rectangle_319" data-name="Rectangle 319" width="591.097" height="322.568" fill="none"/>
            </clipPath>
          </defs>
          <g id="Groupe_283" data-name="Groupe 283" clip-path="url(#clip-path)">
            <path d="M421.067,208.01V194.473a19.747,19.747,0,0,0-19.749-19.747h-212.3a19.747,19.747,0,0,0-19.749,19.747V298.73a11.7,11.7,0,0,0,11.7,11.7h.445v12.141h21.228V310.427H387.691v12.129l21.228.012V310.427h.457a11.7,11.7,0,0,0,11.7-11.7V208.01Z" fill="#fff"/>
            <path d="M161.264,218.9V194.473a27.779,27.779,0,0,1,27.749-27.747h10.253l-.081-68.037L35.52,98.884l.108,90.812c.023,19.384,15.222,35.071,33.948,35.049l91.688-.109Z" fill="#fff"/>
            <path d="M555.572,148.848l.013-50.046-164.519-.044-.018,67.968h10.27a27.779,27.779,0,0,1,27.749,27.747v5.537h.006v24.665l92.255.025c18.908.005,34.24-15.7,34.245-35.08l.005-19.521,35.514.009.006-21.251Z" fill="#fff"/>
            <path d="M435.614,128.083l-53.093,59.162a4.164,4.164,0,0,0,.283,5.883,4,4,0,0,0,.335.274l14.731,11.566a4.867,4.867,0,0,0,6.518-.483l53.146-59.133a4.165,4.165,0,0,0-.348-5.88c-.1-.088-.2-.171-.309-.25L442.16,127.639a4.866,4.866,0,0,0-6.546.444" fill="#3e3e3e"/>
            <path d="M403.812,205.633a14.2,14.2,0,1,1-1.739-20.011,14.2,14.2,0,0,1,1.739,20.011" fill="#fff"/>
            <path d="M403.812,205.633a14.2,14.2,0,1,1-1.739-20.011A14.2,14.2,0,0,1,403.812,205.633Z" fill="none" stroke="#545454" stroke-miterlimit="4.001" stroke-width="5.85"/>
            <path d="M463.388,143.319a17.127,17.127,0,1,1-2.1-24.131,17.127,17.127,0,0,1,2.1,24.131" fill="#9f9f9f"/>
            <path d="M461.149,141.438a14.2,14.2,0,1,1-1.739-20.011A14.2,14.2,0,0,1,461.149,141.438Z" fill="none" stroke="#545454" stroke-miterlimit="4.001" stroke-width="5.85"/>
            <path d="M439.394,123.165a14.205,14.205,0,1,1,1.739,20.014,14.221,14.221,0,0,1-1.739-20.014" fill="#fff"/>
            <path d="M458.908,139.558a11.28,11.28,0,1,0-15.893,1.382,11.294,11.294,0,0,0,15.893-1.382m4.479,3.763a17.13,17.13,0,1,1-2.1-24.135,17.13,17.13,0,0,1,2.1,24.135" fill="#545454"/>
            <path d="M154.62,128.107l53.157,59.105a4.166,4.166,0,0,1-.293,5.883,4.014,4.014,0,0,1-.336.274l-14.706,11.6a4.866,4.866,0,0,1-6.518-.477l-53.206-59.11a4.165,4.165,0,0,1,.343-5.88c.1-.085.2-.166.3-.242l14.706-11.6a4.865,4.865,0,0,1,6.554.447" fill="#3e3e3e"/>
            <path d="M207.338,188.082A13.036,13.036,0,1,1,188.97,186.5a13.036,13.036,0,0,1,18.368,1.579" fill="#fff"/>
            <path d="M208.231,187.331a14.2,14.2,0,1,1-20.012-1.721A14.2,14.2,0,0,1,208.231,187.331Z" fill="none" stroke="#545454" stroke-miterlimit="4.001" stroke-width="5.85"/>
            <path d="M150.835,123.189a14.2,14.2,0,1,1-20.012-1.721,14.2,14.2,0,0,1,20.012,1.721" fill="#fff"/>
            <path d="M150.835,123.189a14.2,14.2,0,1,1-20.012-1.721A14.2,14.2,0,0,1,150.835,123.189Z" fill="none" stroke="#545454" stroke-miterlimit="4.001" stroke-width="5.85"/>
          </g>
        </svg>
      `),
      SvgError: ref(`
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 591.092 322.568">
          <defs>
            <clipPath id="clip-path">
              <rect id="Rectangle_321" data-name="Rectangle 321" width="591.092" height="322.568" fill="#ffff00"/>
            </clipPath>
          </defs>
          <rect id="Rectangle_320" data-name="Rectangle 320" class="animate-pulse" width="34.856" height="30.238" transform="translate(271.572 264.76)" fill="#fff"/>
          <g id="Groupe_286" data-name="Groupe 286">
            <g id="Groupe_285" data-name="Groupe 285" clip-path="url(#clip-path)">
              <path class="animate-pulse" d="M315.671,216.64l.1-.074.1-.066a72.161,72.161,0,0,0,19.962-19.429,44.708,44.708,0,0,0,8.173-25.8c0-14.175-4.727-25.572-14.052-33.872-9.257-8.241-22.117-12.419-38.221-12.419-14.945,0-27.279,3.746-36.659,11.134-9.535,7.509-14.259,18.429-14.04,32.459l.005.308.764,2.291h33.225l.023-1.977c.062-5.392,1.636-9.33,4.81-12.042a17.49,17.49,0,0,1,11.872-4.139c5.77,0,10.046,1.578,13.073,4.822,3.064,3.286,4.553,7.784,4.553,13.75a26.57,26.57,0,0,1-4.149,14.671,53.607,53.607,0,0,1-11.43,12.6l-.035.028-.036.028c-8.706,6.7-14.388,12.28-17.37,17.066-3.062,4.914-4.586,12.293-4.658,22.559l-.014,2.014h34.556v-2c0-5.525.623-9.883,1.851-12.954,1.172-2.931,3.729-5.943,7.6-8.953" fill="#ffff00"/>
              <path d="M416.712,210.936a9.957,9.957,0,0,1-4.582-1.116l-60.624-31.309a52.962,52.962,0,0,1-9.091,23.1,80.113,80.113,0,0,1-21.984,21.46c-3.6,2.828-4.646,4.773-4.933,5.492-.478,1.193-1.279,4.077-1.279,9.981v10H263.607l.071-10.07c.083-11.784,2-20.529,5.868-26.733,3.488-5.6,9.776-11.858,19.219-19.129a45.55,45.55,0,0,0,9.686-10.643,18.233,18.233,0,0,0,2.676-7.245H282.984l-.051,4.445H238.355l-59.349,30.664a9.977,9.977,0,0,1-9.364-.1v89a11.7,11.7,0,0,0,11.7,11.7h.445v12.142h21.229V310.426H388.069v12.13l21.228.012V310.426h.457a11.7,11.7,0,0,0,11.7-11.7V209.745a10.034,10.034,0,0,1-4.738,1.191M314.429,266.759V303H263.573V256.759h50.856Z" class="fill-current"/>
              <path d="M468.74,58.123l-16.9-8.726,17.784-27.44-18.394-9.5-17.79,27.449-43.32-22.372-68.23,105.274a52.261,52.261,0,0,1,13.376,8.615c10.235,9.112,15.806,21.224,16.617,36.03l64.831,33.482,65.25-100.674c9.468-14.609,3.545-33.476-13.228-42.138" class="fill-current"/>
              <path d="M233.056,170.24l-.024-1.542c-.26-16.657,5.489-29.734,17.088-38.869a56.587,56.587,0,0,1,17.616-9.3L201.393,18.208,122.8,58.816c-16.776,8.668-22.764,27.419-13.384,41.886l65,100.249,58.757-30.359Z" class="fill-current"/>
              <path d="M235.623,125.281l-24.616,75.585a4.157,4.157,0,0,1-5.646,2.533l-17.4-6.938a4.866,4.866,0,0,1-2.845-5.884l24.6-75.63a4.163,4.163,0,0,1,5.264-2.642c.122.04.242.086.359.137l17.4,6.939a4.867,4.867,0,0,1,2.889,5.9" fill="#3e3e3e"/>
              <path d="M210.036,200.921a13.036,13.036,0,1,1-7.815-16.7,13.037,13.037,0,0,1,7.815,16.7" fill="#fff"/>
              <path d="M211.132,201.319a14.2,14.2,0,1,1-8.514-18.192A14.2,14.2,0,0,1,211.132,201.319Z" fill="none" stroke="#545454" stroke-miterlimit="4.001" stroke-width="5.85"/>
              <path d="M237.991,119.544a14.2,14.2,0,1,1-8.514-18.192,14.2,14.2,0,0,1,8.514,18.192" fill="#fff"/>
              <path d="M237.991,119.544a14.2,14.2,0,1,1-8.514-18.192A14.2,14.2,0,0,1,237.991,119.544Z" fill="none" stroke="#545454" stroke-miterlimit="4.001" stroke-width="5.85"/>
              <path d="M355.422,125.285l24.641,75.577a4.165,4.165,0,0,0,5.64,2.547l17.386-6.964a4.867,4.867,0,0,0,2.844-5.885l-24.589-75.607a4.166,4.166,0,0,0-5.265-2.642,3.883,3.883,0,0,0-.371.143l-17.394,6.941a4.868,4.868,0,0,0-2.892,5.89" fill="#3e3e3e"/>
              <path d="M406.639,191.634a14.2,14.2,0,1,1-18.194-8.511,14.2,14.2,0,0,1,18.194,8.511" fill="#fff"/>
              <path d="M406.639,191.634a14.2,14.2,0,1,1-18.194-8.511A14.2,14.2,0,0,1,406.639,191.634Z" fill="none" stroke="#545454" stroke-miterlimit="4.001" stroke-width="5.85"/>
              <path d="M382.514,108.867A17.128,17.128,0,1,1,360.574,98.6a17.128,17.128,0,0,1,21.94,10.263" fill="#9f9f9f"/>
              <path d="M379.765,109.864a14.2,14.2,0,1,1-18.194-8.511A14.2,14.2,0,0,1,379.765,109.864Z" fill="none" stroke="#545454" stroke-miterlimit="4.001" stroke-width="5.85"/>
              <path d="M353.056,119.551a14.205,14.205,0,1,1,18.2,8.512,14.222,14.222,0,0,1-18.2-8.512" fill="#fff"/>
              <path d="M377.016,110.863a11.281,11.281,0,1,0-6.76,14.45,11.294,11.294,0,0,0,6.76-14.45m5.5-1.994A17.13,17.13,0,1,1,360.571,98.6a17.131,17.131,0,0,1,21.944,10.265" fill="#545454"/>
            </g>
          </g>
        </svg>
      `),
    };
  },
  computed: {
    StateBackground() {
      let mode_code =
        this.config?.dock?.status?.mode_code != null
          ? this.config.dock?.status.mode_code
          : "";

      let LastPing =
        this.config?.dock?.status?.LastPing != null
          ? parseInt(this.config.dock?.status.LastPing)
          : 0;

      let border = dockStateColor(mode_code, LastPing);

      if (border == " debug-dock") {
        return "border-none" + border;
      } else {
        return "border-" + border;
      }
    },

    CoverStateSvg() {
      let CoverState = this.config?.dock?.status?.cover_state;

      if (CoverState == 0) {
        return this.SvgClose;
      } else if (CoverState == 1) {
        return this.SvgOpening;
      } else if (CoverState == 2) {
        return this.SvgOpen;
      } else if (CoverState == 3) {
        return this.SvgError;
      }

      return this.SvgClose;
    },
  },
  methods: {
    focus() {
      this.config.dock.methods.ShowTheDock();
    },
  },
};
</script>
